var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-view container"},[(_vm.naverUserId != null)?_c('div',[_c('NaverList')],1):_c('div',[_c('NaverLoginButton',{on:{"result":_vm.result}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }